<div *ngIf="veBasicDetails$ | async as veBasicDetails" class="valuation-event-info">
  <div *ngIf="showTitleInfo">
    <h2>{{'valEventSetupForm.pageTitle' | translate | uppercase}}</h2>
    <p>{{'valEventSetupForm.pageDescription' | translate}}</p>
  </div>
  <div class="fieldsContainer">
    <span class="headerTitle">{{ 'valEventSetupForm.projectsInfo' | translate }}</span>
    <div class="rowContainer">
      <div class="fieldTitle">
        <div class="labelContainer">
          <span class="dialogLabel uppercase">{{ 'valEventSetupForm.projectID' | translate }}</span>
        </div>
        <div class="fieldContainer">
          {{veBasicDetails.ProjectId}}
        </div>
      </div>
      <div class="fieldTitle">
        <div class="labelContainer">
          <span class="dialogLabel uppercase">{{ 'valEventSetupForm.projectName' | translate }}</span>
        </div>
        <div class="fieldContainer">
          {{veBasicDetails.ProjectName}}
        </div>
      </div>
    </div>
    <span class="headerTitle">{{ 'valEventSetupForm.valuationEventInfo' | translate }}</span>
    <div class="rowContainer">
      <div class="fieldTitle">
        <div class="labelContainer">
          <span class="dialogLabel uppercase">{{ 'valEventSetupForm.valuationEventName' | translate }}</span>
        </div>
        <div class="fieldContainer">
          <input type="text" [ngClass]="disableEditing ? 'disabled' : ''" placeholder="Seagull Portfolio Q1 VE" [(ngModel)]="veBasicDetails.VEName" (ngModelChange)="detectChange('VEName', $event)">
        </div>
      </div>
      <div class="fieldTitle">
        <div class="labelContainer">
          <span class="dialogLabel uppercase">{{ 'valEventSetupForm.valuationDate' | translate }}</span>
        </div>
        <div class="fieldContainer">
          <input type="date" [ngClass]="disableEditing ? 'disabled' : ''" [ngModel]="veBasicDetails.ValuationDate | date:'yyyy-MM-dd'" (ngModelChange)="detectChange('ValuationDate', $event)">
        </div>
      </div>
      <div class="fieldTitle">
        <div class="labelContainer">
          <span class="dialogLabel uppercase">{{ 'valEventSetupForm.estimatedNumProperties' | translate }}</span>
        </div>
        <div class="fieldContainer">
          <input type="number" [ngClass]="disableEditing ? 'disabled' : ''" [(ngModel)]="veBasicDetails.NumOfPropertiesManual" (ngModelChange)="detectChange('NumOfPropertiesManual', $event)">
        </div>
      </div>
    </div>
    <div class="rowContainer">
      <div class="fieldTitle">
        <div class="labelContainer">
          <span class="dialogLabel uppercase">{{ 'valEventSetupForm.signedReceivedDate' | translate }}</span>
        </div>
        <div class="fieldContainer">
          <input type="date" [ngClass]="disableEditing ? 'disabled' : ''" [ngModel]="veBasicDetails.SignedAndReceivedDate | date:'yyyy-MM-dd'" (ngModelChange)="detectChange('SignedAndReceivedDate', $event)">
        </div>
      </div>
      <div class="fieldTitle">
        <div class="labelContainer">
          <span class="dialogLabel uppercase">{{ 'valEventSetupForm.draftDeadline' | translate }}</span>
        </div>
        <div class="fieldContainer">
          <input type="date" [ngClass]="disableEditing ? 'disabled' : ''" [ngModel]="veBasicDetails.DeadlineDraftDate | date:'yyyy-MM-dd'" (ngModelChange)="detectChange('DeadlineDraftDate', $event)">
        </div>
      </div>
      <div class="fieldTitle">
        <div class="labelContainer">
          <span class="dialogLabel uppercase">{{ 'valEventSetupForm.finalDeadline' | translate }}</span>
        </div>
        <div class="fieldContainer">
          <input type="date" [ngClass]="disableEditing ? 'disabled' : ''" [ngModel]="veBasicDetails.DeadlineFinalDate | date:'yyyy-MM-dd'" (ngModelChange)="detectChange('DeadlineFinalDate', $event)">
        </div>
      </div>
    </div>
    <div class="rowContainer">
      <div class="fieldTitle">
        <div class="labelContainer">
          <span class="dialogLabel uppercase">
            {{ 'valEventSetupForm.instructionDate' | translate }}
          </span>
        </div>
        <div class="fieldContainer">
          <input type="date" [ngClass]="disableEditing ? 'disabled' : ''" [ngModel]="veBasicDetails.InstructionDate | date:'yyyy-MM-dd'" (ngModelChange)="detectChange('InstructionDate', $event)">
        </div>
      </div>
      <div class="fieldTitle">
        <div class="labelContainer">
          <span class="dialogLabel uppercase">{{ 'valEventSetupForm.reportDate' | translate }}</span>
        </div>
        <div class="fieldContainer">
          <input type="date" [ngClass]="disableEditing ? 'disabled' : ''" [ngModel]="veBasicDetails.ReportDate | date:'yyyy-MM-dd'" (ngModelChange)="detectChange('ReportDate', $event)">
        </div>
      </div>
    </div>
    <div class="rowContainer">
      <div class="fieldTitle full-width">
        <div class="labelContainer">
          <span class="dialogLabel uppercase">{{ 'valEventSetupForm.comments' | translate }}</span>
        </div>
        <div class="fieldContainer">
          <input class="commentPlaceholder" [ngClass]="disableEditing ? 'disabled' : ''" type="text" placeholder="{{ 'valEventSetupForm.commentPlaceholder' | translate }}" [(ngModel)]="veBasicDetails.Comments" (ngModelChange)="detectChange('Comments', $event)">
        </div>
      </div>
    </div>
  </div>
  <p *ngIf="veBasicDetails.ModifiedBy" class="lastSavedOn">
    {{ 'valEventSetupForm.lastSavedOn' | translate }} {{ veBasicDetails.ModifiedOn | date: 'dd/MM/yyyy' }} by {{veBasicDetails.ModifiedBy}}
  </p>
</div>
